var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ui segment" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", [
      _c("b", [_vm._v("Use constraints:")]),
      _vm._v(
        "\n    " +
          _vm._s(_vm.getI18n(_vm.dataConstraint.accessUseConstraint, "en")) +
          "\n  "
      )
    ]),
    _vm._v(" "),
    _c("br"),
    _vm._v(" "),
    _c("div", [
      _c("b", [_vm._v("Data policy:")]),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: { href: _vm.getI18n(_vm.dataConstraint.urlDataPolicy, "en") }
        },
        [_vm._v(_vm._s(_vm.getI18n(_vm.dataConstraint.urlDataPolicy, "en")))]
      )
    ]),
    _vm._v(" "),
    _c("br"),
    _vm._v(" "),
    _vm.dataConstraint.embargo != null
      ? _c("div", [
          _c("b", [_vm._v("Access constraints:")]),
          _vm._v(
            "\n    Public with an embargo of " +
              _vm._s(_vm.dataConstraint.embargo.duration) +
              " years.\n  "
          )
        ])
      : _c("div", [
          _c("b", [_vm._v("Access constraints:")]),
          _vm._v(" Public\n  ")
        ]),
    _vm._v(" "),
    _c("br"),
    _vm._v(" "),
    _vm.dataConstraint.licence != null
      ? _c("div", [
          _c("b", [_vm._v("Licence:")]),
          _vm._v(" "),
          _c("a", { attrs: { href: _vm.dataConstraint.licence.url } }, [
            _vm._v(_vm._s(_vm.dataConstraint.licence.title))
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ui top attached label" }, [
      _c("i", { staticClass: "exclamation circle icon" }),
      _vm._v(" Data access and use constraints:\n  ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }